<div class="sk-cms-login {{isPreview ? '': 'sk-component REGISTRATION'}}" sk-class="$data.isNavFixed ? 'fixed': ''"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
    <div class="login-main">
        {{if style.customer.styleType !== "hide"}}
        <div class="items-left">
            {{if content.kefu.icon.src}}
            <div class="items-icon small">
                <img src="{{content.kefu.icon.src}}" />
            </div>
            {{/if}}
            <div class="items-text {{style.customer.styleType === "custom" ? style.customer.fontSize : ''}}"
                {{if style.customer.styleType === "custom"}}
                 style="color: {{style.customer.color}}"
                {{/if}}>
                {{content.kefu.model}}
            </div>
        </div>
        {{/if}}

        {{if style.language.model !== "hide"}}
        <div class="items-left">
            {{each content.language.items}}
            {{if $value.optionId === content.language.value && $value.icon.src}}
            <div class="items-icon small">
                <img src="{{$value.icon.src}}" />
            </div>
            {{/if}}
            {{/each}}

            <div class="items-select">
                {{each content.language.items}}
                {{if $value.optionId === content.language.value}}
                <div class="select-value">
                    <div class="select-text {{style.language.model === "custom" ? style.language.font : ''}}"
                    {{if style.language.model === "custom"}}
                    style="color: {{style.language.color}}"
                    {{/if}}>
                        {{$value.optionValue}}
                    </div>
                    <div class="select-icon"
                        {{if style.language.model === "custom"}}
                        style="border-color: {{style.language.color}}"
                        {{/if}}>
                    </div>
                </div>
                {{/if}}
                {{/each}}
                {{if !isDesign}}
                <ul class="select-list"
                    {{if style.language.model === "custom"}}
                        style="background-color: {{style.language.bgcolor}}; border-color: {{style.language.bgcolor}}"
                    {{/if}}>
                    {{each content.language.items}}
                    <li>
                        {{if $value.link}}
                        <a class="items-link goto-link" href="{{$value.link}}" target="blank">
                        {{$value.optionValue}}
                        </a>
                        {{else}}
                        {{$value.optionValue}}
                        {{/if}}
                    </li>
                    {{/each}}
                </ul>
                {{/if}}
            </div>
        </div>
        {{/if}}

        {{if style.loginbtn.styleType !== "hide" || style.regbtn.styleType !== "hide"}}
        <div class="items-right" {{isDesign ? '' : 'sk-if=!$data.isLogin'}} cms-not-replace>
            {{if style.loginbtn.styleType !== "hide"}}
            <div class="items-text items-link {{style.loginbtn.styleType === "custom" ? style.loginbtn.fontSize : ''}}"
            {{if style.loginbtn.styleType === "custom"}}
             style="color: {{style.loginbtn.color}}"
            {{/if}}>
                <a class="goto-link" {{isDesign ? '' : 'sk-prop.href=$data.link'}} cms-not-replace>
                    {{content.loginText}}
                </a>
            </div>
            {{/if}}
            {{if style.regbtn.styleType !== "hide"}}
            <div class="items-text u-ml5 items-link {{style.regbtn.styleType === "custom" ? style.regbtn.fontSize : ''}}"
                {{if style.regbtn.styleType === "custom"}}
                style="color: {{style.regbtn.color}}"
                {{/if}}>
                <a class="goto-link" {{isDesign ? '' : 'sk-prop.href=$data.regLink'}} cms-not-replace>
                    {{content.regText}}
                </a>
            </div>
            {{/if}}
        </div>
        {{/if}}

        {{if style.logout.styleType !== "hide"}}
        <div class="items-right" {{isDesign ? '' : 'sk-if=$data.isLogin'}} cms-not-replace>
            {{if content.logout.icon.src}}
            <div class="items-icon items-link small" sk-event.click="logout()">
                <img src="{{content.logout.icon.src}}" />
            </div>
            {{/if}}
            <div class="items-text {{style.logout.styleType === "custom" ? style.logout.fontSize : ''}}"
                {{if style.logout.styleType === "custom"}}
                 style="color: {{style.logout.color}}"
                {{/if}} sk-event.click="logout()">
                <a class="items-link">
                    {{content.logout.model}}
                </a>
            </div>
        </div>
        {{/if}}

        {{if style.person.styleType !== "hide"}}
        <div class="items-right" {{isDesign ? '' : 'sk-if=$data.isLogin'}} cms-not-replace>
            {{if content.person.icon.src}}
            <div class="items-icon">
                <img src="{{content.person.icon.src}}" sk-if="!$data.headImgUrl" cms-not-replace/>
                <img sk-prop.src="$data.headImgUrl" sk-if="$data.headImgUrl" cms-not-replace/>
            </div>
            {{/if}}
            <div class="items-text {{style.person.styleType === "custom" ? style.person.fontSize : ''}}"
                {{if style.person.styleType === "custom"}}
                 style="color: {{style.person.color}}"
                {{/if}}>
                <a class="goto-link" {{isDesign ? '' : 'sk-prop.href=$data.userLink'}} cms-not-replace>
                {{content.person.model}}
                </a>
            </div>
        </div>
        {{/if}}

    </div>
</div>
